import React from 'react';
import DatePicker from 'components/molecules/common/Form/DatePicker';
import { FormData } from './OptimizePlan';
import SelectWithInfiniteScroller from 'components/atoms/SelectWithInfiniteScroller';
import dayjs from 'dayjs';
interface IProps {
    setFormData: React.Dispatch<React.SetStateAction<FormData>>;
    formData: FormData;
}

export const optimizeOptions = [
    { label: 'Maximize Stat Volume', value: 'maximize_stat_volume', disabled: false, constraintKey: 'Volume Stat' },
    {
        label: 'Maximize Net Price $',
        value: 'maximize_net_price',
        disabled: false,
        constraintKey: 'GP Net Price $ Sales',
    },
    {
        label: 'Maximize Net Price less MDF / stat',
        value: 'maximize_net_price_less_mdfsat',
        disabled: false,
        constraintKey: 'Net Price / Stat',
    },
    { label: 'Maximize TTL GP GM$', value: 'maximize_ttl_gp_gm', disabled: false, constraintKey: 'GP GM $' },
    {
        label: 'Maximize Total Profit Pool',
        value: 'maximize_total_profit_pool',
        disabled: false,
        constraintKey: 'GP GM/Stat',
    },
    {
        label: 'Maximize Retailer $ Sales',
        value: 'maximize_retailer_sales',
        disabled: false,
        constraintKey: 'Retailer Sales $',
    },
    {
        label: 'Minimize Total Trade Spend Incl MDF ($s)',
        value: 'minimize_total_trade_spend_incl_mdf',
        disabled: false,
        constraintKey: 'Trade Gross Margin Incl MDF ISM $s',
    },
    {
        label: 'Minimize Total Trade Spend Incl MDF (% of List)',
        value: 'minimize_total_trade_spend_incl_mdf_of_list',
        disabled: false,
        constraintKey: 'Trade Spend Incl MDF %',
    },
    {
        label: 'Minimize Total Working Investment  ($S) (Trade + MDF + ISM)',
        value: 'minimize_total_working_investment_trade_mdf_ism',
        disabled: false,
        constraintKey: 'Total Trade Spend %',
    },
    {
        label: 'Maximize Retailer Margin $s',
        value: 'retailer_margin',
        disabled: false,
        constraintKey: 'Retailer Margin $',
    },
    {
        label: 'Maximize Retailer Margin %',
        value: 'retailer_margin_percent',
        disabled: false,
        constraintKey: 'Retailer Profit %',
    },
];

const OptimizePlanForm: React.FC<IProps> = ({ setFormData, formData }) => {
    return (
        <div className="flex gap-4 px-2 py-3 bg-[rgba(250,250,250,1)] rounded-lg mb-3">
            <div className="flex flex-1 gap-4">
                <div className="text-right flex gap-1 items-center">
                    <>
                        {true && <span className="text-redTriangle">*</span>}
                        Objective:
                    </>
                </div>
                <SelectWithInfiniteScroller
                    hasMore={false}
                    showSearch={false}
                    filterOption={false}
                    placeholder={`Select Multiple...`}
                    maxTagCount="responsive"
                    className="dropdown-height !h-8 !w-48"
                    showArrow
                    onChange={(val) => {
                        setFormData((prev) => ({
                            ...prev,
                            objective: val,
                        }));
                    }}
                    value={formData.objective}
                    options={optimizeOptions}
                />
            </div>
            <DatePicker
                value={formData.start_date}
                label="Start Date"
                isRequired={true}
                onChange={(date: number | null) => {
                    setFormData((prev) => ({ ...prev, start_date: date }));
                }}
                format="MM/DD/YYYY"
                showToday={true}
                className="flex-1 !h-8 !w-48"
                enabledDates={{ start: dayjs().startOf('day').unix() }}
            />
        </div>
    );
};

export default React.memo(OptimizePlanForm);
